import { PopupRelations, popupRelationsFromResponse } from './PopupRelations';

export interface Popup {
  id: number;
  title: string;
  image: string;
  linkUrl: string;
  maxShowPerUser?: number;
  delaySeconds: number;
  showInHome: boolean;
  showInAllProducts: boolean;
  showInAllCategories: boolean;
  showInAllBrands: boolean;
  isActive: boolean;
  relations: PopupRelations;
  createdAt: Date;
  updatedAt: Date;
}

export const popupFromResponse = (responseData: any): Popup => ({
  id: responseData.id,
  title: responseData.title,
  image: responseData.image,
  linkUrl: responseData.link_url,
  maxShowPerUser: responseData.max_show_per_user,
  delaySeconds: responseData.delay_seconds,
  showInHome: responseData.show_in_home,
  showInAllProducts: responseData.show_in_all_products,
  showInAllCategories: responseData.show_in_all_categories,
  showInAllBrands: responseData.show_in_all_brands,
  isActive: responseData.is_active,
  relations: popupRelationsFromResponse(responseData.relations),
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
